import React, { Component } from 'react';
import Button from "../elements/Buttons";
import VeryDissatisfied from '../elements/feedback_svg/VeryDissatisfied';
import Dissatisfied from '../elements/feedback_svg/Dissatisfied';
import Neutral from '../elements/feedback_svg/Neutral';
import Satisfied from '../elements/feedback_svg/Satisfied';
import VerySatisfied from '../elements/feedback_svg/VerySatisfied';

class FeedbackPopup extends Component{
    constructor(props){
        super(props);
    }
    render(){
        return(
            <div id="fb-popup" className="fb-modal">
                <div className="fb-modal-content">
                    <div className="fb-modal-header">
                        {/* <div className="fb-close" onClick={this.props.cancelH}>&times;</div> */}
                        <h3>Are you satisfied with the provided support?</h3>
                    </div>
                    <div className="fb-modal-body">
                        <div className="fimage_cloned">
                            {/* <div className="feedbYes"><img src={upThumbImage} alt="Yes" /></div> 
                            <div className="feedbNo"><img src={downThumbImage} alt="No" /></div> */}
                            <div onClick={this.props.iconAction} data-type="feedIcon" className="veryDissatisfied"><VeryDissatisfied /></div> 
                            <div onClick={this.props.iconAction} data-type="feedIcon" className="dissatisfied"><Dissatisfied /></div>
                            <div onClick={this.props.iconAction} data-type="feedIcon" className="neutral"><Neutral /></div> 
                            <div onClick={this.props.iconAction} data-type="feedIcon" className="satisfied"><Satisfied /></div>
                            <div onClick={this.props.iconAction} data-type="feedIcon" className="verySatisfied"><VerySatisfied /></div>
                        </div>
                        <input type="hidden" id="txt_feedback2_convid"/>
                        {/* <textarea row='3' className='form-control body' name='txt_feedback2' id='txt_feedback2' placeholder='Enter your comments...'></textarea>
                        <span className='error_span error_feedtext2'></span> */}
                        <div className="clearfix"></div>
                        <Button
                            id="sendFeedb"
                            classes=""
                            title="Submit"
                            hoverTitle="Submit"
                            action={this.props.action}
                        />
                        <Button
                            id="cancelFeedb"
                            classes="cancelFeedb"
                            title="Skip"
                            hoverTitle="Skip"
                            action={this.props.action}
                        />
                    </div>
                </div>
            
            </div>
        )
    }
}
FeedbackPopup.propTypes = {
    cancelH: React.propTypes.node,
    action: React.propTypes.node,
    iconAction: React.propTypes.node,
}
export default FeedbackPopup;